import { RootState } from 'src/app/store';
import { createSelector } from '@reduxjs/toolkit';
import { ProfileInfo } from 'src/features/profile/types';
import { DutyStatus } from 'src/common/types';

const getState = (state: RootState): ProfileInfo => state.profile;

export const getProfileInfo = createSelector(getState, (state: ProfileInfo) => state);
export const getDriverInfo = createSelector(getState, (state: ProfileInfo) => state.driver);
export const getFirestoreDriver = createSelector(
  getState,
  (state: ProfileInfo) => state.firestoreDriver,
);
export const getUserId = createSelector(
  getState,
  (state: ProfileInfo): number => state.driver.employeeId,
);
export const getDutyStatus = createSelector(
  getState,
  (state: ProfileInfo): DutyStatus => state.dutyStatus,
);
export const getPatchDutyStatusSuccess = createSelector(
  getState,
  (state: ProfileInfo) => state.dutyStatusSuccess,
);

export const getDriverPermissions = createSelector(getDriverInfo, info => info.permissions);
export const getDriverConfig = createSelector(getState, (state: ProfileInfo) => state.driverConfig);
export const getRuleset = createSelector(getState, state => state.firestoreRuleset);
